import { useModelHistory } from '@api/useModelHistory'
import { GraviGrid } from '@gravitate-js/excalibrr'
import React, { useCallback, useMemo } from 'react'
import { getColumnDefs } from './columnDefs'

import { useUserSettings } from '@hooks/settings'
import { gridViewManager } from '@/utils/grid'

const STORAGE_KEY = 'model-optimizer'

export function Grid({ setHistoryId, gridAPIRef }) {
  const { useModelHistoryQuery } = useModelHistory()
  const { data: modelHistory, isFetching } = useModelHistoryQuery()
  const { updateSetting } = useUserSettings()

  const columnDefs = useMemo(getColumnDefs, [])
  const getRowId = useCallback((row) => row.data?.id, [])
  const agPropOverrides = useMemo(() => ({ getRowId, rowHeight: 60 }), [getRowId])

  const onSelectionChanged = useCallback(
    (props) => {
      setHistoryId(props.api.getSelectedRows()[0].id)
    },
    [setHistoryId]
  )

  const onFirstDataRendered = useCallback((params) => {
    params.api.getDisplayedRowAtIndex(0).setSelected(true)
  }, [])

  const onGridConfigChanged = useCallback((config) => {
    updateSetting(`gridConfig::${STORAGE_KEY}`, config)
  }, [])

  return (
    <GraviGrid
      rowSelection='single'
      rowGroupPanelShow='never'
      storageKey={STORAGE_KEY}
      className='model-run-history-grid'
      controlBarProps={{
        title: 'History',
      }}
      loading={isFetching}
      externalRef={gridAPIRef}
      agPropOverrides={agPropOverrides}
      columnDefs={columnDefs}
      rowData={modelHistory?.rows}
      onSelectionChanged={onSelectionChanged}
      onFirstDataRendered={onFirstDataRendered}
      onGridConfigChanged={onGridConfigChanged}
      {...gridViewManager(STORAGE_KEY, updateSetting)}
    />
  )
}
